export default {
  loginInfo: {
    username: "",
    password: "",
    captchaCode: "",
  },
};



// WEBPACK FOOTER //
// ./src/model/login/user.js